const fruits = document.querySelectorAll('.swatch_pr_item');
fruits.forEach(myFunction);

 
function myFunction(item, index) {
  // item.addEventListener('click',function(){
  // let quantity = document.querySelector('#quantity_number');
  //   quantity.value = 5;
  //     console.log('clicked');
  // })
}